import { ThunkAction } from 'redux-thunk'
import { loadProfile } from '.'
import { RootState } from '..'
import { fuelImportApi } from '../../apis'
import { FuelImportEntity, FuelImportFilter } from '../../models'
import {
  FuelImportAction,
  SET_FUEL_IMPORTS,
  SET_FUEL_IMPORTS_LOADED,
  SET_FUEL_IMPORT_FILTER,
  SET_SELECTED_FUEL_IMPORT,
} from '../types'

export const setFuelImports = (
  fuelImports: FuelImportEntity[]
): FuelImportAction => ({
  type: SET_FUEL_IMPORTS,
  payload: fuelImports,
})

export const setFuelImportFilter = (
  filter: FuelImportFilter
): FuelImportAction => ({
  type: SET_FUEL_IMPORT_FILTER,
  payload: {
    ...filter,
    importDateFrom: new Date(
      new Date(filter.importDateFrom).setHours(0, 0, 0, 0)
    ).getTime(),
    importDateTo: new Date(
      new Date(filter.importDateTo).setHours(23, 59, 59, 999)
    ).getTime(),
  },
})

export const setSelectedFuelImport = (
  selectedFuelImport?: FuelImportEntity
): FuelImportAction => ({
  type: SET_SELECTED_FUEL_IMPORT,
  payload: selectedFuelImport,
})

export const setFuelImportsLoaded = (loaded: boolean): FuelImportAction => ({
  type: SET_FUEL_IMPORTS_LOADED,
  payload: loaded,
})

export const loadFuelImports = (): ThunkAction<
  void,
  RootState,
  null,
  FuelImportAction
> => {
  return async (dispatch) => {
    try {
      dispatch(setFuelImportsLoaded(false))
      const resp = await fuelImportApi.getFuelImports()
      dispatch(setFuelImports(resp.data.data))
    } catch (e) {
      if (e.response && e.response.status && e.response.status === 401) {
        dispatch(loadProfile())
        const resp = await fuelImportApi.getFuelImports()
        dispatch(setFuelImports(resp.data.data))
      }
    } finally {
      dispatch(setFuelImportsLoaded(true))
    }
  }
}
